/**
 * @generated SignedSource<<72b03ed3411721089eccdbdb19c63290>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaperBookmarkButtonBookmarkMutation$variables = {
  id: string;
};
export type PaperBookmarkButtonBookmarkMutation$data = {
  readonly bookmarkPaper: {
    readonly " $fragmentSpreads": FragmentRefs<"PaperBookmarkButtonFragment">;
  };
};
export type PaperBookmarkButtonBookmarkMutation = {
  response: PaperBookmarkButtonBookmarkMutation$data;
  variables: PaperBookmarkButtonBookmarkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PaperBookmarkButtonBookmarkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Paper",
        "kind": "LinkedField",
        "name": "bookmarkPaper",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PaperBookmarkButtonFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "PaperBookmarkButtonBookmarkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Paper",
        "kind": "LinkedField",
        "name": "bookmarkPaper",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bookmarkCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewerBookmarked",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9137056d022063ad99648fe2bd7a44b8",
    "id": null,
    "metadata": {},
    "name": "PaperBookmarkButtonBookmarkMutation",
    "operationKind": "mutation",
    "text": "mutation PaperBookmarkButtonBookmarkMutation(\n  $id: ID!\n) {\n  bookmarkPaper(id: $id) {\n    ...PaperBookmarkButtonFragment\n    id\n  }\n}\n\nfragment PaperBookmarkButtonFragment on Paper {\n  id\n  bookmarkCount\n  viewerBookmarked\n}\n"
  }
};
})();

(node as any).hash = "33f635b8847ea118d044a542607b593b";

export default node;
